import { Box, BoxProps, Text } from 'grommet';
import { EditReviewAnalysis } from 'lib/api';

export const ClassifiersList = ({ analysis, ...props }: BoxProps & { analysis: EditReviewAnalysis }) => (
  <Box gap="xsmall" {...props}>
    <Text weight="bold">Classifiers Detected:</Text>
    <ul style={{ margin: '4px 0' }}>
      {analysis.foreground && <li>Foreground ({analysis.foregroundFrameCount || 0} frames)</li>}
      {analysis.interactsWithProduct && <li>Interacts with Product</li>}
      {analysis.reactsToNarration && <li>Reacts to Narration</li>}
      {analysis.voice && <li>Speaks</li>}
    </ul>
  </Box>
);
